import { render, staticRenderFns } from "./ShipmentLabels.vue?vue&type=template&id=5b603d66"
import script from "./ShipmentLabels.vue?vue&type=script&lang=js"
export * from "./ShipmentLabels.vue?vue&type=script&lang=js"
import style0 from "./ShipmentLabels.vue?vue&type=style&index=0&id=5b603d66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports